"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIntersectionObserver = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireDefault(require("react"));
var useIntersectionObserver = exports.useIntersectionObserver = function useIntersectionObserver(targetRef, options) {
  var observerRef = _react["default"].useRef(null);
  var _React$useState = _react["default"].useState(false),
    _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
    isIntersecting = _React$useState2[0],
    setIsIntersecting = _React$useState2[1];
  var handleEntries = function handleEntries(entries) {
    entries.forEach(function (entry) {
      setIsIntersecting(entry.isIntersecting);
    });
  };
  _react["default"].useEffect(function () {
    if (targetRef !== null && targetRef !== void 0 && targetRef.current) {
      var observer = new IntersectionObserver(handleEntries, options);
      observer.observe(targetRef.current);
      observerRef.current = observer;
    }
    return function () {
      var currentObserver = observerRef.current;
      currentObserver === null || currentObserver === void 0 ? void 0 : currentObserver.disconnect();
      observerRef.current = null;
    };
  }, [options, targetRef]);
  return isIntersecting;
};
var _default = exports["default"] = useIntersectionObserver;